export const GAME_CONFIG = {
  QUESTION_TIMER_SECONDS: 12,
};

export default GAME_CONFIG; 